import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import {EmployeeAppraisalHistory, QueryResult} from '@app/shared';

@Injectable()
export class AppraisalHistoryDataService {

  constructor (private http: HttpClient) { }

  getMyAppraisalHistory(): Observable<QueryResult> {
    const url = `/hr/appraisal-histories/self?start=0&count=-1`;
    return this.http.get<QueryResult>(url);
  }

  searchAppraisalHistory(userId: number): Observable<QueryResult> {
    const url = `/hr/appraisal-histories/search?user.id=${userId}&start=0&count=-1`;
    return this.http.get<QueryResult>(url);
  }

  updateAppraisalHistory(appraisalHistories: EmployeeAppraisalHistory[]): Observable<any> {
    return this.http.put(`/hr/appraisal-histories/employees/${appraisalHistories[0].userId}`, appraisalHistories);
  }
}
